import React, { useEffect } from 'react'
import { getPresenceMessage } from '../../utils'
import PresenceTooltip from '../PresenceTooltip/PresenceTooltip'
import {
  Container,
  StyledVersionHeading,
  StyledAvatarStack,
  StackedAvatar,
  IconContainer,
} from './SharePresenceItem.styles'
import { ReactComponent as CursorIcon } from 'icons/cursor-9.svg'
import useUserProfile from 'modules/user/useUserProfile'
import { usePresences } from 'modules/presence/operations'

interface SharePresenceItemProps {
  shareIdentifier: string
  onPresenceReady: () => void
}

const SharePresenceItem = ({
  shareIdentifier,
  onPresenceReady,
}: SharePresenceItemProps) => {
  const { presences, loading } = usePresences(shareIdentifier)
  const { data: userData } = useUserProfile()

  useEffect(() => {
    if (!loading) {
      onPresenceReady()
    }
  }, [onPresenceReady, loading])

  if (!presences.length) {
    return null
  }

  const { names, message } = getPresenceMessage(
    presences,
    userData!.me!.identifier!
  )

  return (
    <Container>
      <IconContainer>
        <CursorIcon width="9" height="14" />
      </IconContainer>
      <PresenceTooltip presences={presences}>
        <StyledAvatarStack
          avatarSize={24}
          avatarMargin={-4}
          maxAvatars={3}
          tooltipDisabled={true}
          totalCount={presences.length}
          showTotalCountInBadge={true}>
          {presences.map((presence, index) => (
            <StackedAvatar
              key={presence.user.identifier}
              src={presence!.user!.avatarUrl}
              name={presence!.user!.name!}
              size={24}
              zIndex={presences.length - index}
              data-testid="presence-avatar"
            />
          ))}
        </StyledAvatarStack>
      </PresenceTooltip>
      <StyledVersionHeading emphasize={false} suffix={message}>
        {names}
      </StyledVersionHeading>
    </Container>
  )
}

export default SharePresenceItem
